import React, { Fragment, useEffect, useState } from "react";
import {
  Col,
  Card,
  CardBody,
  CardHeader
} from "reactstrap";
import {
  H6,
  Spinner
} from "../../../../AbstractElements";
import { useSelector, useDispatch } from "react-redux";
import { fetchCodeOTP } from "Features/Learning/OTP/otpUtils";

const CodeOTP = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.CodeOTP?.data);
  const isLoading = useSelector((state) => state?.CodeOTP?.isLoading);
  const [timer, setTimer] = useState(915);
  const [refatch, setRefatch] = useState(false);
  const [sixLastDigit, setSixLastDigit] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (data?.otp) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      setSixLastDigit(data?.otp.slice(-6));

      return () => clearInterval(countdown);
    }
  }, [data?.otp]);

  useEffect(() => {
    if (timer === 0) {
      setTimer(915); // Reset the timer
      setRefatch(!refatch); // Trigger refetch
    }
  }, [timer]);

  useEffect(() => {
    dispatch(fetchCodeOTP());
  }, [refatch]);

  return (
    <Fragment>
      {isLoading ? (
        <Col lg="12">
          <div className="loader-box">
            <Spinner attrSpinner={{ className: "loader-30" }} />
          </div>
          <H6 attrH6={{ className: "sub-title mb-0 text-center" }}>
            {"Data Loading..."}
          </H6>
        </Col>
      ) : (
        data?.otp && (
          <Card>
            <CardHeader className="pb-0">
              <h2 className="text-center">OTP</h2>
            </CardHeader>
            <CardBody>
              <Col md="12" className="text-center">
                <h1 className="text-center">{sixLastDigit}</h1>
                {data?.otp && (
                  <p> This code will expire in {timer} seconds</p>
                )}
              </Col>
            </CardBody>
          </Card>
        )
      )}
    </Fragment>
  );
};

export default CodeOTP;
